import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";

import css from "./bar_preview.less";

const BarPreview = ({ animated = false, content }) => (
  <div className={css.barPreview}>
    <div className={css.barPreviewBarChart}>
      <div className={classNames({ [css.barPreviewLoading]: animated }, css.barPreviewBar)} />
      <div className={classNames({ [css.barPreviewLoading]: animated }, css.barPreviewBar)} />
      <div className={classNames({ [css.barPreviewLoading]: animated }, css.barPreviewBar)} />
      <div className={classNames({ [css.barPreviewLoading]: animated }, css.barPreviewBar)} />
    </div>
    <h3>{content}</h3>
  </div>
);

BarPreview.propTypes = {
  animated: PropTypes.bool,
  content: PropTypes.string
};

export default BarPreview;
